// extracted by mini-css-extract-plugin
export default {"node":"KNodeItem-module__node--elX1R","last":"KNodeItem-module__last--TM85M","act":"KNodeItem-module__act--dZeph"};